import React,{useEffect,useState} from 'react';
import api from '../../services/api';
import { getCountryCode } from '../../services/country';

export default function MunicipalitySelect({province,value,onChange,required=false}){
  const [items,setItems]=useState([]);
  const isDominicanRepublic=getCountryCode()==='DO';
  useEffect(()=>{
    if(!province||!isDominicanRepublic){setItems([]);return;}
    api.get('/municipalities',{params:{province}}).then(r=>setItems(r.data));
  },[province,isDominicanRepublic]);
  if(!isDominicanRepublic) return <input value={value||''} onChange={onChange} required={required} placeholder="Ciudad o distrito"/>;
  return <select value={value||''} onChange={onChange} disabled={!province} required={required}><option value="">{province?'Seleccionar municipio':'Selecciona una provincia primero'}</option>{items.map(item=><option key={item} value={item}>{item}</option>)}</select>;
}
